export const ProgressStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh'
}

export const noWrapTextStyle = {
  fontSize: 'inherit',
  whiteSpace: 'nowrap'
}